import React from 'react';
import { AiFillCloseCircle } from 'react-icons/ai';
import {
  PopupCloseButton, PopupContainer, PopupHeader, PopupWrapper,
} from './popupElements';

const backgroundAnim = {
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.2,
    },
    transitionEnd: {
      display: 'none',
    },
  },
  show: {
    display: 'flex',
    opacity: 1,
    transition: {
      duration: 0.2,
    },
  },
};

const wrapperAnim = {
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.2,
    },
    transitionEnd: {
      display: 'none',
    },
  },
  show: {
    display: 'flex',
    opacity: 1,
    transition: {
      delay: 0.2,
      duration: 0.2,
    },
  },
};

const Popup = (props) => {
  const {
    trigger, children, setOpen, header,
  } = props;
  return (
    <PopupContainer
      initial="hidden"
      animate={trigger ? 'show' : 'hidden'}
      variants={backgroundAnim}
    >
      <PopupWrapper
        initial="hidden"
        animate={trigger ? 'show' : 'hidden'}
        variants={wrapperAnim}
      >
        {header ? (<PopupHeader>{header}</PopupHeader>) : ''}
        <PopupCloseButton onClick={() => setOpen(false)}><AiFillCloseCircle /></PopupCloseButton>
        { children }
      </PopupWrapper>
    </PopupContainer>
  );
};

export default Popup;
